import {
  PortableText,
  type PortableTextBlock,
  type PortableTextReactComponents,
} from '@portabletext/react'
import React from 'react'

import { RichTextBlock } from '../Sections/SectionRichText/RichTextBlock'

import './RichText.scss'

type Props = {
  content: PortableTextBlock[]
}

const portableTextComponents: Partial<PortableTextReactComponents> = {
  block: RichTextBlock,
  types: {},
}

export const RichText: React.FC<Props> = ({ content }) => {
  return (
    <div className="flexible-program-rich-text">
      <PortableText value={content} components={portableTextComponents} />
    </div>
  )
}
